import React from 'react';
import { useLocation, useParams, Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  Container,
} from '@chakra-ui/react';

function EventGuestBookingSuccess() {
  const { urlTitle } = useParams();
  const { state } = useLocation();
  const email = state?.email || '';
  const totalAmount = state?.totalAmount;
  const paymentMethod = state?.paymentMethod;
  const paymentStatus = state?.paymentStatus;
  const eventName = state?.variantName
    ? `${state?.eventName || 'Evento'} — ${state.variantName}`
    : state?.eventName || 'Evento';
  const quantity = state?.quantity || 1;
  const isPendingCashPayment =
    paymentMethod === 'contanti' &&
    paymentStatus === 'pending' &&
    Number(totalAmount) > 0;

  return (
    <Box bg="#36393f" minH="100vh" color="white" py={12}>
      <Container maxW="container.md">
        <VStack spacing={6} align="stretch" textAlign="center">
          <Heading size="lg">Prenotazione confermata</Heading>
          <Text fontSize="lg">
            Grazie! La prenotazione per <strong>{eventName}</strong> è stata
            registrata.
          </Text>
          {quantity > 1 ? <Text>Partecipanti: {quantity}</Text> : null}
          {Number(totalAmount) > 0 ? (
            <Text>Totale: €{Number(totalAmount).toFixed(2)}</Text>
          ) : null}
          {isPendingCashPayment ? (
            <Text>
              Ricorda di completare il pagamento in sede per confermare
              definitivamente il posto.
            </Text>
          ) : null}
          {email ? (
            <Text>
              Abbiamo inviato a <strong>{email}</strong> il riepilogo ordine e
              la ricevuta in PDF.
            </Text>
          ) : null}
          <Text fontSize="sm" color="gray.300">
            Per modifiche o cancellazioni contatta la segreteria CIL a{' '}
            <Text
              as="a"
              href="mailto:info@cilassociazione.it"
              color="blue.300"
              textDecoration="underline"
            >
              info@cilassociazione.it
            </Text>{' '}
            oppure{' '}
            <Text
              as={RouterLink}
              to="/contattaci"
              color="blue.300"
              textDecoration="underline"
            >
              usa il modulo di contatto
            </Text>
            .
          </Text>
          <Button
            as={RouterLink}
            to={`/event/${encodeURIComponent(urlTitle || '')}`}
            colorScheme="blue"
          >
            Torna all&apos;evento
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}

export default EventGuestBookingSuccess;
